import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { MuniSpinner2, TextInput } from "../../../../../components";
import { Button } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import CropTest from "./CropTest";
import { Lock } from "@mui/icons-material";
import { axios } from "../../../../../utils/axios";
import CropTestREC from "./CropTestREC";
import { aprobarDenuncia } from "./handlers";
import { aprobarDenunciaSchema } from "./schemas";
import { Alert } from "@mui/material";
import LocaleIcon from "../../../../../components/svgs/LocaleIcon";

const FormCompletarAprobarInfraccion = (props) => {
  const { infraccion_seleccionada, datosTitular, setInfraccionesNuevas } = props;
  const [crop, setCrop] = useState(null);
  const [crop2, setCrop2] = useState(null);
  const [crop3, setCrop3] = useState(null);
  const [fotoPatenteSeleccionada, setFotoPatenteSeleccionada] = useState(null);
  const [fotoInfraccion2, setFotoInfraccion2] = useState(null);
  const [fotoInfraccion3, setFotoInfraccion3] = useState(null);


  const VerEnGoogleMaps = ({ lat, lng }) => {
    const abrirEnGoogleMaps = () => {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    };

    return (
      <Button size="sm" onClick={abrirEnGoogleMaps}>
        <div className="d-flex align-items-center gap-1">
          <span>
            Ver ubicación en Google Maps
          </span>
          <LocaleIcon width={15} height={15} color="#fff" />
        </div>
      </Button>
    );
  };


  const formRef = useRef(null);
  const methods = useForm({
    mode: "all",
    resolver: yupResolver(aprobarDenunciaSchema),
    defaultValues: {
      id: infraccion_seleccionada?.id,

      nombre: datosTitular?.razonSocial,
      // apellido_titular: datosTitular?.titular?.renaper?.apellido,
      documento: datosTitular?.documento,
      direccion_titular: datosTitular?.direccion_titular,
      // direccion_infraccion: ,
      provincia: datosTitular?.provincia,
      localidad: datosTitular?.localidad,
      codigo: datosTitular?.codigo_postal,
      // razonSocial: datosTitular?.titular?.nombre,

      patente: datosTitular?.dominio?.replaceAll("-", ""),
      marca: datosTitular?.vehiculo?.marca,
      modelo: datosTitular?.vehiculo?.modelo,

      latitud: infraccion_seleccionada.latitud,
      longitud: infraccion_seleccionada.longitud,
    },
  });

  useEffect(()=>{

    methods.setValue('nombre',datosTitular?.razonSocial)
    methods.setValue("documento",datosTitular?.documento)
    methods.setValue("direccion_titular",datosTitular?.direccion_titular)
    methods.setValue("provincia",datosTitular?.provincia)
    methods.setValue("localidad",datosTitular?.localidad)
    methods.setValue("codigo",datosTitular?.codigo_postal)
    methods.setValue("patente",datosTitular?.dominio?.replaceAll("-", ""),)
    methods.setValue("marcar",datosTitular?.vehiculo?.marca,)
    methods.setValue("modelo",datosTitular?.vehiculo?.modelo,)

  },[datosTitular])

  useEffect(() => {
    formRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <FormProvider {...methods}>
      <div ref={formRef}></div>
      <form
        // className="container"
        onSubmit={methods.handleSubmit((data) =>
          aprobarDenuncia(data, setInfraccionesNuevas, methods.setError)
        )}
      >
        <fieldset className="row  p-2" disabled={methods.formState.isSubmitting}>
          <h5 className="m-0">Datos Titular</h5>
          <div className="col-12 col-md-4 ">
            <TextInput name="nombre" label="Razon Social *" />
          </div>
          <div className="col-12 col-md-2 ">
            <TextInput name="documento" label="Documento *" />
          </div>
          <div className="col-12 col-md-6">
            <TextInput name="direccion_titular" label="Dirección *" />
          </div>

          <div className="col-12 col-md-6 col-lg-5">
            <TextInput name="provincia" label="Provincia *" />
          </div>
          <div className="col-12 col-md-6 col-lg-5">
            <TextInput name="localidad" label="Localidad *" />
          </div>
          <div className="col-12 col-md-6 col-lg-2">
            <TextInput name="codigo" label="C.P *" />
          </div>

          <div className="row col-12">
            <h5 className="m-0">Datos Vehiculo</h5>
            <div className="col-4 ">
              <TextInput name="patente" label="Patente *" />
            </div>
            <div className="col-4 ">
              <TextInput name="marca" label="Marca *" />
            </div>
            <div className="col-4 ">
              <TextInput name="modelo" label="Modelo *" />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <TextInput name="direccion_infraccion" label="Dirección de la infracción *" />
              <div className="mt-2">
                <VerEnGoogleMaps lat={infraccion_seleccionada?.latitud} lng={infraccion_seleccionada?.longitud} />
              </div>
            </div>

            {/* <div className="col-12 col-md-6 col-lg-4">
            <TextInput name="razonSocial" label="Razón Social *" />
          </div> */}

          </div>
          <hr className="my-3" />
          <h5 className="m-0">Imágenes para el acta</h5>

          <Alert color="info">Seleccione y recorte la imágen de la patente</Alert>
          <div className="col-12  d-flex justify-content-center gap-3 mb-3" style={{ height: "60px" }}>
            {infraccion_seleccionada.fotos.map((foto, i) => {
              return (
                <React.Fragment key={i}>
                  <img
                    src={foto.file}
                    className="image-selection  "

                    style={{
                      background: "#777",
                      objectFit: "contain",
                      aspectRatio: "3/4",
                      height: "100%",
                      opacity:
                        fotoPatenteSeleccionada !== null && fotoPatenteSeleccionada !== i
                          ? "0.5"
                          : 1,
                      border:
                        fotoPatenteSeleccionada !== null && fotoPatenteSeleccionada === i
                          ? "2px solid var(--primary)"
                          : "none",
                    }}
                    onClick={() => {
                      if (fotoInfraccion2 !== null && fotoInfraccion2 === i) {
                        return;
                      }
                      setFotoPatenteSeleccionada(i);
                    }}
                  />
                  {fotoInfraccion2 !== null && fotoInfraccion2 === i && <Lock />}
                </React.Fragment>
              );
            })}
          </div>

          {fotoPatenteSeleccionada !== null ? (
            <div style={{maxWidth:"500px"}} className="mx-auto">
              <CropTestREC
                foto={infraccion_seleccionada.fotos[fotoPatenteSeleccionada]}
                setValue={methods.setValue}
                key={fotoPatenteSeleccionada}
                i={fotoPatenteSeleccionada}
              />
            </div>
          ) : null}

          <hr />
          <div className="d-flex justify-content-center">
            <Button size="sm" type="submit"
            disabled={!methods.watch('foto_infraccion1') || !methods.watch('foto_patente')}
            >
              {methods.formState.isSubmitting ? (
                <span className="d-flex justify-content-center gap-1">
                  <MuniSpinner2
                    width="18px"
                    height="18px"
                    circularProgressSize={24}
                    circularProgressColor="#ffffff"
                    fileName="bola-blanca.png"
                  />
                </span>
              ) : (
                "Aprobar Infracción"
              )}
            </Button>
          </div>
        </fieldset>
      </form>
    </FormProvider>
  );
};

export default FormCompletarAprobarInfraccion;
